module.exports = __webpack_public_path__ + "img/mask-image-left.4ec55f1d.png";